import { render, staticRenderFns } from "./register-event.vue?vue&type=template&id=70e662a8&scoped=true"
import script from "./register-event.vue?vue&type=script&lang=js"
export * from "./register-event.vue?vue&type=script&lang=js"
import style0 from "./register-event.vue?vue&type=style&index=0&id=70e662a8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e662a8",
  null
  
)

export default component.exports